import axios from "axios";
const token = sessionStorage.getItem('authorization');
const configHeader = {
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'multipart/form-data',
        'X-AUTH-TOKEN': token,
        'withCredentials': true,
    }
}
const basePhp = "http://192.168.12.3";
const portPhp = "5555";
const baseJava = "http://192.168.12.3";
const portJava = "8080";
const schemaHostname = ['localhost', '172.16.111.205'].includes(window.location.hostname) ? 'https://vedika.rsabhk.co.id/simrs_harkit/' : 'https://vedika.rsabhk.co.id/simrs_harkit/';
const schemaHostname2 = ['localhost', '172.16.111.205', '127.0.0.1'].includes(window.location.hostname) ? 'https://vedika.rsabhk.co.id/' : 'https://vedika.rsabhk.co.id/';

export const snakePhp = `${schemaHostname}service/`;
export const snakePhp2 = `${schemaHostname2}api/`;
export const snakeJavaSDM = `${schemaHostname}:${portJava}jasamedika-sdm/`;
export const snakeAxios = (token ? axios.create(configHeader) : axios.create());
export const snakeAxios2 = axios.create();
snakeAxios.interceptors.request.use(
    response => response,
    error => {
        // // Handle the error
        // if (error.response) {
        //     // Server responded with a status other than 2xx
        //     alert(`Error: ${error.response.status} - ${error.response.data.message || error.message}`);
        // } else if (error.request) {
        //     // Request was made but no response received
        //     alert('Error: No response received from server.');
        // } else {
        //     // Something happened in setting up the request
        //     alert(`Error: ${error.message}`);
        // }
        return Promise.reject(error); // Reject the promise to propagate 
    }
);
// For POST requests
snakeAxios.interceptors.response.use(
    response => response,
    error => {
        // // Handle the error
        // if (error.response) {
        //     // Server responded with a status other than 2xx
        //     alert(`Error: ${error.response.status} - ${error.response.data.message || error.message}`);
        // } else if (error.request) {
        //     // Request was made but no response received
        //     alert('Error: No response received from server.');
        // } else {
        //     // Something happened in setting up the request
        //     alert(`Error: ${error.message}`);
        // }
        return Promise.reject(error); // Reject the promise to propagate 
    }
);
snakeAxios2.interceptors.request.use(
    response => response,
    error => {
        // // Handle the error
        // if (error.response) {
        //     // Server responded with a status other than 2xx
        //     alert(`Error: ${error.response.status} - ${error.response.data.message || error.message}`);
        // } else if (error.request) {
        //     // Request was made but no response received
        //     alert('Error: No response received from server.');
        // } else {
        //     // Something happened in setting up the request
        //     alert(`Error: ${error.message}`);
        // }
        return Promise.reject(error); // Reject the promise to propagate the error
    }
);
// For POST requests
snakeAxios2.interceptors.response.use(
    response => response,
    error => {
        // Handle the error
        // if (error.response) {
        //     // Server responded with a status other than 2xx
        //     alert(`Error: ${error.response.status} - ${error.response.data.message || error.message}`);
        // } else if (error.request) {
        //     // Request was made but no response received
        //     alert('Error: No response received from server.');
        // } else {
        //     // Something happened in setting up the request
        //     alert(`Error: ${error.message}`);
        // }
        return Promise.reject(error); // Reject the promise to propagate the error
    }
);